module.exports = __webpack_public_path__ + "img/placeholder-gif.47cbb1c3.gif";